export const BASE_POSITIONS = {
  START: "Start",
  CENTER: "Center",
  END: "End",
  STRETCH: "Stretch"
};
